var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category"},[_c('ul',_vm._l((_vm.categoryList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.clickCategory(item)}}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.type))]),_c('span',{staticClass:"count"},[_vm._v("("+_vm._s(item.count)+")")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-084788a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/assembly/Category.vue
// module id = null
// module chunks = 